// Linear easing function (no easing, just linear motion)
export const linearEase = (t) => t; // No easing, t is directly the progress

// Smooth scroll function with linear smooth motion
export const scrollToElement = (id) => {
  const element = document.getElementById(id);
  if (!element) return;

  const targetPosition =
    element.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;

  // Duration for the scroll effect (adjust as necessary)
  const duration = 1500;
  let startTime = null;

  // Animation function to perform smooth scrolling with linear progression
  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;

    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1); // Progress should not exceed 1
    const ease = linearEase(progress); // Apply linear easing (no acceleration/deceleration)

    window.scrollTo(0, startPosition + distance * ease); // Scroll to the position with linear easing

    // Continue animation until the duration is completed
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
};
